<template>
  <v-img
    :height="height"
    :width="width"
    :contain="contain"
    :cover="cover"
    class="inline-svg-img"
    :style="cssVars"
  >
    <div
      class="inline-svg-img__content"
      v-html="svgContent"
    />
  </v-img>
</template>

<script>
export default {
  name: "InlineSvgImg",

  props: {
    colors: {
      type: Object,
      default: () => ({ 1: "#000000", 2: "#000000", 3: "#000000" })
    },
    width: { type: [String, Number], default: "auto" },
    height: { type: [String, Number], default: "auto" },
    contain: Boolean,
    cover: Boolean,
    src: { required: true },
  },

  data() {
    return { svgContent: "" };
  },

  computed: {
   cssVars() {
      if (!this.colors) return {};
      return Object.entries(this.colors).reduce((acc, [key, value]) => {
        if (value) {
          acc[`--svg-color-${key}`] = value;
        }
        return acc;
      }, {});
    }
  },

  watch: {
    src: {
      immediate: true,
      handler() {
        this.loadSvg();
      }
    }
  },

  methods: {
    async loadSvg() {
      try {
        const url = typeof this.src === "string" ? this.src : this.src;
        const res = await fetch(url);
        let text = await res.text();

        text = text.replace("<svg", '<svg class="inline-svg-img__svg"');

        this.svgContent = text;
      } catch (e) {
        this.svgContent = "";
      }
    }
  }
};
</script>

<style scoped>
.inline-svg-img__content {
  width: 100%;
  height: 100%;
  display: flex;
}

.inline-svg-img__content :deep(.inline-svg-img__svg) {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
